import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { BotCategory } from '../../../openapi';

export type BotCategoryColor = 'success' | 'premium' | 'info' | 'warning' | 'danger' | 'warning-light';

export interface BotCategoryMeta {
  category: BotCategory;
  title: string;
  description: string;
  icon: IconProp;
  color: BotCategoryColor;
}

export const BOT_CATEGORY_META: Record<number, BotCategoryMeta> = {
  [BotCategory.SEO]: {
    category: BotCategory.SEO,
    title: 'SEO crawlers',
    description: 'Search engine indexing bots. Blocking these will hurt SEO.',
    icon: 'magnifying-glass',
    color: 'success',
  },
  [BotCategory.AIScraper]: {
    category: BotCategory.AIScraper,
    title: 'AI scrapers',
    description: 'Bots that crawl content to train AI models.',
    icon: 'robot',
    color: 'premium',
  },
  [BotCategory.AITool]: {
    category: BotCategory.AITool,
    title: 'AI tools',
    description: 'AI assistants fetching pages on behalf of a user (e.g. ChatGPT browsing).',
    icon: 'wand-magic-sparkles',
    color: 'info',
  },
  [BotCategory.Tool]: {
    category: BotCategory.Tool,
    title: 'Monitoring & tools',
    description: 'Uptime monitoring, performance audits and similar utilities.',
    icon: 'gauge',
    color: 'warning',
  },
  [BotCategory.Ads]: {
    category: BotCategory.Ads,
    title: 'Ads',
    description: 'Advertising platform crawlers (e.g. Google Ads quality checks).',
    icon: 'rectangle-ad',
    color: 'danger',
  },
  [BotCategory.Preview]: {
    category: BotCategory.Preview,
    title: 'Link previews',
    description: 'Bots that fetch metadata to render link previews in chat apps.',
    icon: 'image',
    color: 'warning-light',
  },
  [BotCategory.Social]: {
    category: BotCategory.Social,
    title: 'Social media',
    description: 'Open-graph crawlers from social networks.',
    icon: 'thumbs-up',
    color: 'info',
  },
};

export const getBotCategoryMeta = (category: BotCategory): BotCategoryMeta =>
  BOT_CATEGORY_META[category] ?? {
    category,
    title: 'Other bots',
    description: 'Bots that don’t fall into a specific category.',
    icon: 'robot',
    color: 'info',
  };
